export function loginObj({ email, password, isWeb }) {
  let obj = {
    email,
    password,
    isWeb,
  };
  return obj;
}

export function editStatusUserObj({ status }) {
  let obj = {
    status,
  };
  return obj;
}

export function addBankObj({ bank_name, status }) {
  let obj = {
    bank_name,
    status,
  };
  return obj;
}

export function editBankObj({ bank_name, status }) {
  let obj = {
    bank_name,
    status,
  };
  return obj;
}

export function addCityObj({ name, state_id, status }) {
  let obj = {
    name,
    state_id,
    status,
  };
  return obj;
}

export function addCountryObj({ name, country_code, status }) {
  let obj = {
    name,
    country_code,
    status,
  };
  return obj;
}

export function editCountryObj({ name, country_code, status }) {
  let obj = {
    name,
    country_code,
    status,
  };
  return obj;
}

export function addStateObj({ state_name, state_code, country_id, status }) {
  let obj = {
    state_name,
    state_code,
    country_id,
    status,
  };
  return obj;
}

export function editStateObj({ state_name, state_code, country_id, status }) {
  let obj = {
    state_name,
    state_code,
    country_id,
    status,
  };
  return obj;
}

export function editCityObj({ name, status, state_id }) {
  let obj = {
    name,
    status,
    state_id,
  };
  return obj;
}

export function editCommissionObj({ data }) {
  let obj = {
    data,
  };
  return obj;
}
